import { stickyBottomBarFirstTriggerStyles } from "components/StickyBottomBar";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import { DataContextProvider } from "contexts/DataContext";
import { ModalContextProvider } from "contexts/ModalContext";
import { StickyBottomBarContextProvider } from "contexts/StickyBottomBarContext";
import CustomHead from "modules/common/components/CustomHead";
import { PressLogos } from "modules/common/components/PressLogos";
import StickyBottomBarAdapter from "modules/storyblok/adapters/StickyBottomBar";
import BreadcrumbsSchema from "modules/storyblok/components/BreadcrumbsSchema";
import { GlobalComponentsWrapper } from "modules/storyblok/globalComponents/GlobalComponentsWrapper";
import { useOptimizelySnippet } from "hooks/useOptimizely/useOptimizely";
import type { AirHelpScoreWrapperTemplateProps } from "./AirHelpScoreWrapper.d";

const AirHelpScoreWrapper = ({
  story,
  cmsLanguagesData,
  serverSideStoryblokPages,
  children,
  whiteListDomains,
  nofollowUrls,
  globalComponents,
  optimizelyExperiments,
}: AirHelpScoreWrapperTemplateProps) => {
  const {
    content: {
      metaTitle,
      metaDescription,
      breadcrumbsParentPage,
      breadcrumbsPositionName,
      stickyBottomBarHeading,
      stickyBottomBarButtonText,
      stickyBottomBarBenefits,
      stickyBottomBarHideBenefits,
      hideStickyBottomBar,
      stickyBottomBarVariant,
    },
  } = story;
  useOptimizelySnippet(optimizelyExperiments);

  return (
    <DataContextProvider
      data={{ cmsLanguagesData, serverSideStoryblokPages, whiteListDomains, nofollowUrls, optimizelyExperiments }}
    >
      <CustomHead title={metaTitle} description={metaDescription} />
      <BreadcrumbsSchema
        breadcrumbsPositionName={breadcrumbsPositionName}
        breadcrumbsParentPage={breadcrumbsParentPage}
      />
      <ModalContextProvider>
        <GlobalComponentsWrapper globalComponents={globalComponents}>
          <StickyBottomBarTrigger type="first" styles={stickyBottomBarFirstTriggerStyles} />
          {children}
          <PressLogos />
        </GlobalComponentsWrapper>
      </ModalContextProvider>
      <StickyBottomBarAdapter
        showStickyBottomBar={!hideStickyBottomBar}
        stickyBottomBarVariant={stickyBottomBarVariant}
        stickyBottomBarHeading={stickyBottomBarHeading}
        stickyBottomBarButtonText={stickyBottomBarButtonText}
        stickyBottomBarBenefits={stickyBottomBarBenefits}
        stickyBottomBarHideBenefits={stickyBottomBarHideBenefits}
      />
    </DataContextProvider>
  );
};

export const AirHelpScoreAdapter = (props: AirHelpScoreWrapperTemplateProps) => (
  <StickyBottomBarContextProvider threshold={0.4}>
    <AirHelpScoreWrapper {...props} />
  </StickyBottomBarContextProvider>
);
